import { useState } from 'react';
import { cn } from '@/lib/utils';
import type { IEvent } from '@/interfaces';
import { DataTable, HeaderPage } from './components';
import { EventDetailsModal } from './components/dataTable/components';
import useEvents from './hooks/useEvents';

const EventPage = () => {
	const eventsData = useEvents();
	const [selectedEvent, setSelectedEvent] = useState<IEvent | null>(null);

	return (
		<div className={cn('flex flex-col space-y-4 pb-20', 'animate__animated animate__fadeIn')}>
			<HeaderPage
				isLoading={eventsData.isLoading}
				activeFilters={eventsData.activeFilters}
				handleFilterChange={eventsData.handleFilterChange}
				handlePeriodChange={eventsData.handlePeriodChange}
			/>

			<DataTable data={eventsData} onViewDetails={setSelectedEvent} />

			<EventDetailsModal
				event={selectedEvent}
				isOpen={!!selectedEvent}
				onClose={() => setSelectedEvent(null)}
			/>
		</div>
	);
};

export default EventPage;
